/**
 * Timeframes y rangos de zoom compartidos por grafica-modelo y multicharts-dialog.
 * `periodo` es el código que usa el backend (1=1m … 6=D, 7=4H, 8=W).
 */
export const TIMEFRAME_TO_PERIODO: Record<string, number> = {
  '1m': 1, '5m': 2, '15m': 3, '30m': 4, '1H': 5, '4H': 7, 'D': 6, 'W': 8,
};

export const PERIODO_TO_TIMEFRAME: Record<number, string> = {
  1: '1m', 2: '5m', 3: '15m', 4: '30m', 5: '1H', 7: '4H', 6: 'D', 8: 'W',
};

/** Opciones del selector de timeframe, en orden de menor a mayor. */
export const TIMEFRAME_OPTIONS: ReadonlyArray<{ label: string; periodo: number }> =
  Object.entries(TIMEFRAME_TO_PERIODO).map(([label, periodo]) => ({ label, periodo }));

/** Botones de rango de zoom. */
export const RANGES: string[] = ['1M', '3M', '6M', 'YTD', '1Y', '5Y', 'All'];

/** Días que cubre cada rango ('YTD' y 'All' se calculan aparte). */
export const RANGE_DAYS: Record<string, number> = {
  '1M': 30, '3M': 90, '6M': 180, '1Y': 365, '5Y': 1825,
};

const DAY_MS = 24 * 60 * 60 * 1000;

/** Inicio (ms) del rango `range` contando hacia atrás desde `nowMs`. No aplica a 'All'. */
export function rangeFromMs(range: string, nowMs: number = Date.now()): number {
  return range === 'YTD'
    ? new Date(new Date(nowMs).getFullYear(), 0, 1).getTime()
    : nowMs - (RANGE_DAYS[range] ?? 365) * DAY_MS;
}

/** D y W son diarios/semanales; el resto es intradía (velas con hora). */
export function isPeriodoIntraday(periodo: number): boolean {
  return periodo !== 6 && periodo !== 8;
}
